import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';


export const kymw15Handlers = [

  /** マーク関係 */
  // マークファイル情報検索 /kymw15/getMarkFile
  http.post(PlessService.SERVICE.getMarkFile.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getMarkFile.url, req);
    return HttpResponse.json(getMarkFileResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マークファイル活性区分変更 /kymw15/updateMarkFileEnabled
  http.post(PlessService.SERVICE.updateMarkFileEnabled.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateMarkFileEnabled.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マークファイル情報削除 /kymw15/deleteMarkFile
  http.post(PlessService.SERVICE.deleteMarkFile.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.deleteMarkFile.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク画像ファイル出力 /kymw15/getMarkImageDownload
  http.post(PlessService.SERVICE.getMarkImageDownload.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getMarkImageDownload.url, req);
    return HttpResponse.json(getMarkImageDownloadResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マークファイル登録 /kymw15/registMarkFile
  http.post(PlessService.SERVICE.registMarkFile.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registMarkFile.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マークファイル適用期間登録 /kymw15/registMarkFilePeriod
  http.post(PlessService.SERVICE.registMarkFilePeriod.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registMarkFilePeriod.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マークファイル適用期間修正 /kymw15/updateMarkFilePeriod
  http.post(PlessService.SERVICE.updateMarkFilePeriod.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateMarkFilePeriod.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク掲載順一覧取得 /kymw15/getMarkPublishOrderList
  http.post(PlessService.SERVICE.getMarkPublishOrderList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getMarkPublishOrderList.url, req);
    return HttpResponse.json(getMarkPublishOrderListResponse);
    // return HttpResponse.json(getMarkPublishOrderListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク掲載順更新 /kymw15/getMarkPublishOrderList
  http.post(PlessService.SERVICE.updateMarkPublishOrder.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateMarkPublishOrder.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク情報登録 /kymw15/registMark
  http.post(PlessService.SERVICE.registMark.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registMark.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 登録可能マークファイル一覧取得 /kymw15/getMarkFileList
  http.post(PlessService.SERVICE.getMarkFileList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getMarkFileList.url, req);
    return HttpResponse.json(getMarkFileListResponse);
    // return HttpResponse.json(getMarkFileListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  /** アイコン関係 */
  // アイコン情報一覧取得 /kymw15/getCwsIconData
  http.post(PlessService.SERVICE.getCwsIconData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCwsIconData.url, req);
    return HttpResponse.json(getCwsIconDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // アイコン情報削除 /kymw15/deleteCwsIconFileData
  http.post(PlessService.SERVICE.deleteCwsIconFileData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.deleteCwsIconFileData.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  /** 関連関係 */
  // マーク変換情報取得 /kymw15/getMarkConvInfo
  http.post(PlessService.SERVICE.getMarkConvInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getMarkConvInfo.url, req);
    return HttpResponse.json(getMarkConvInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // アイコン変換情報取得 /kymw15/getCwsIconConvInfo
  http.post(PlessService.SERVICE.getCwsIconConvInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCwsIconConvInfo.url, req);
    return HttpResponse.json(getCwsIconConvInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク変換情報更新 /kymw15/updateCwsMarkConv
  http.post(PlessService.SERVICE.updateCwsMarkConv.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCwsMarkConv.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // マーク変換情報更新 /kymw15/updateCwsIconConv
  http.post(PlessService.SERVICE.updateCwsIconConv.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCwsIconConv.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  
    // アイコン情報登録 /kymw15/registCwsIconData
  http.post(PlessService.SERVICE.registCwsIconData.url, async ({ request }) => {
    const req = await request;
    console.log(PlessService.SERVICE.registCwsIconData.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  
  // CWSアイコン基本情報取得 /kymw15/getCwsIconBaseData
  http.post(PlessService.SERVICE.getCwsIconBaseData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCwsIconBaseData.url, req);
    return HttpResponse.json(getCwsIconBaseDataResponse);
    // return HttpResponse.json(getCwsIconBaseDataResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 別アイコンファイル情報登録 /kymw15/registCwsIconFileData
  http.post(PlessService.SERVICE.registCwsIconFileData.url, async ({ request }) => {
    const req = await request;
    console.log(PlessService.SERVICE.registCwsIconFileData.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // アイコン情報更新 /kymw15/updateCwsIconData
  http.post(PlessService.SERVICE.updateCwsIconData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCwsIconData.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  
  // アイコン掲載順一覧取得 /kymw15/getCwsIconPublishOrderList
  http.post(PlessService.SERVICE.getCwsIconPublishOrderList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCwsIconPublishOrderList.url, req);
    return HttpResponse.json(getCwsIconPublishOrderListResponse);
    // return HttpResponse.json(getCwsIconPublishOrderListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // アイコン掲載順更新 /kymw15/updateCwsIconPublishOrder
  http.post(PlessService.SERVICE.updateCwsIconPublishOrder.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCwsIconPublishOrder.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // CWSアイコンファイル適用期間更新 /kymw15/updateCwsIconFilePeriod
  http.post(PlessService.SERVICE.updateCwsIconFilePeriod.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCwsIconFilePeriod.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getMarkFileResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MarkCode": "0",
        "MarkCodeBranch": "01",
        "MarkName": "test",
        "MarkFileName": "000_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkGroupCode": "01",
        "SupplyPromoteMarkDiv": "0",
        "StartOrderCode": "2004010",
        "StartDelivCatalogId": "20040304",
        "EndOrderCode": "9999999",
        "EndDelivCatalogId": "",
        "DelivEndDate": "20251127",
        "RegistDate": "20240216",
        "FileRegistDate": "20060311"
      },
      {
        "MarkCode": "1",
        "MarkCodeBranch": "71",
        "MarkName": "９９：表紙掲載",
        "MarkFileName": "001_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkGroupCode": "02",
        "SupplyPromoteMarkDiv": "2",
        "StartOrderCode": "2024130",
        "StartDelivCatalogId": "20240603",
        "EndOrderCode": "",
        "EndDelivCatalogId": "",
        "DelivEndDate": "20251127",
        "RegistDate": "20060311",
        "FileRegistDate": "20060311"
      },
      {
        "MarkCode": "2",
        "MarkCodeBranch": "01",
        "MarkName": "９９：今週のおすすめ",
        "MarkFileName": "002_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//002_01.png?20250106143205",
        "MarkGroupCode": "07",
        "SupplyPromoteMarkDiv": "0",
        "StartOrderCode": "0000000",
        "StartDelivCatalogId": "",
        "EndOrderCode": "9999999",
        "EndDelivCatalogId": "",
        "DelivEndDate": "20251127",
        "RegistDate": "20060514",
        "FileRegistDate": "20060514"
      },
      {
        "MarkCode": "5",
        "MarkCodeBranch": "01",
        "MarkName": "９９：スーパープライス",
        "MarkFileName": "005_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkGroupCode": "01",
        "SupplyPromoteMarkDiv": "2",
        "StartOrderCode": "2023160",
        "StartDelivCatalogId": "20230701",
        "EndOrderCode": "2024120",
        "EndDelivCatalogId": "20240602",
        "DelivEndDate": "20241127",
        "RegistDate": "20090204",
        "FileRegistDate": "20090204"
      },
      {
        "MarkCode": "12",
        "MarkCodeBranch": "01",
        "MarkName": "０１：くらし応援",
        "MarkFileName": "012_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark/012_01.png?20240723095345",
        "MarkGroupCode": "02",
        "SupplyPromoteMarkDiv": "2",
        "StartOrderCode": "2023250",
        "StartDelivCatalogId": "20230901",
        "EndOrderCode": "2023370",
        "EndDelivCatalogId": "20231105",
        "DelivEndDate": "20231127",
        "RegistDate": "20230602",
        "FileRegistDate": "20230602"
      },
      {
        "MarkCode": "12",
        "MarkCodeBranch": "01",
        "MarkName": "０１：くらし応援",
        "MarkFileName": "012_02",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark/012_01.png?20240723095345",
        "MarkGroupCode": "02",
        "SupplyPromoteMarkDiv": "2",
        "StartOrderCode": "2023250",
        "StartDelivCatalogId": "20230901",
        "EndOrderCode": "2023370",
        "EndDelivCatalogId": "20231105",
        "DelivEndDate": "",
        "RegistDate": "20230602",
        "FileRegistDate": "20230602"
      },
    ],
  },
};

const getMarkImageDownloadResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    "obj": {
      "FileName": "/tmp/peace/data/WebData/downloadtemp/MARK_012_20240723_100637.zip"
    }
  },
};

const getCwsIconDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "IconCode": "100",
        "IconCodeBranch": "01",
        "IconGroupCode": "01",
        "IconName": "IconName",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconAlternativeText": "アイコン代替テキスト",
        "DelivCatalogIdStart": "20240910",
        "DelivCatalogIdEnd": "2026105",
        "DelivEndDate": "20261027",
        "IconDiv": "指定",
        "ArrangeDiv": "上部",
        "IconExplain": "アイコン説明",
        "OutputDiv": "00010111",
        "UpdateDate": "2012-07-09 14:08:05"
      },
      {
        "IconCode": "101",
        "IconCodeBranch": "01",
        "IconGroupCode": "01",
        "IconName": "テスト1",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconAlternativeText": "アイコン代替テキスト",
        "DelivCatalogIdStart": "20240910",
        "DelivCatalogIdEnd": "2024105",
        "DelivEndDate": "20221027",
        "IconDiv": "指定",
        "ArrangeDiv": "上部",
        "IconExplain": "アイコン説明",
        "OutputDiv": "11111111",
        "UpdateDate": "2012-07-09 14:08:05"
      },
      {
        "IconCode": "102",
        "IconCodeBranch": "01",
        "IconGroupCode": "01",
        "IconName": "テスト2",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconAlternativeText": "アイコン代替テキスト",
        "DelivCatalogIdStart": "20240910",
        "DelivCatalogIdEnd": "2024105",
        "DelivEndDate": "20261027",
        "IconDiv": "指定",
        "ArrangeDiv": "上部",
        "IconExplain": "アイコン説明",
        "OutputDiv": "00000110",
        "UpdateDate": "2012-07-09 14:08:05"
      },
      {
        "IconCode": "103",
        "IconCodeBranch": "01",
        "IconGroupCode": "01",
        "IconName": "テスト3",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconAlternativeText": "アイコン代替テキスト",
        "DelivCatalogIdStart": "20240910",
        "DelivCatalogIdEnd": "2024105",
        "DelivEndDate": "20221027",
        "IconDiv": "指定",
        "ArrangeDiv": "上部",
        "IconExplain": "アイコン説明",
        "OutputDiv": "01010000",
        "UpdateDate": "2012-07-09 14:08:05"
      },
      {
        "IconCode": "103",
        "IconCodeBranch": "01",
        "IconGroupCode": "01",
        "IconName": "テスト4",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconAlternativeText": "アイコン代替テキスト",
        "DelivCatalogIdStart": "20240910",
        "DelivCatalogIdEnd": "2024105",
        "DelivEndDate": "",
        "IconDiv": "指定",
        "ArrangeDiv": "上部",
        "IconExplain": "アイコン説明",
        "OutputDiv": "01010000",
        "UpdateDate": "2012-07-09 14:08:05"
      }
    ],
  },
};

const getMarkConvInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "IconCode": "100",
        "IconGroupCode": "01",
        "IconName": "IconName",
        "IconCodeBranch": "01",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkList": [
          {
            "MarkFileName": "001-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "MarkFileName": "002-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "MarkFileName": "003-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
        ]
      },
      {
        "IconCode": "101",
        "IconGroupCode": "01",
        "IconName": "テスト1",
        "IconCodeBranch": "01",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkList": [
          {
            "MarkFileName": "001-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "MarkFileName": "003-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
        ]
      },
      {
        "IconCode": "102",
        "IconGroupCode": "01",
        "IconName": "テスト2",
        "IconCodeBranch": "01",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkList": []
      },
      {
        "IconCode": "103",
        "IconGroupCode": "01",
        "IconName": "テスト3",
        "IconCodeBranch": "01",
        "IconImageUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "MarkList": [
          {
            "MarkFileName": "001-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "MarkFileName": "002-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "MarkFileName": "003-01",
            "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
        ]
      }
    ],
  },
};

const getCwsIconConvInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MarkCode": "100",
        "MarkGroupCode": "01",
        "MarkName": "MarkName",
        "MarkCodeBranch": "01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconList": [
          {
            "IconFileName": "100-01",
            "IconUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "IconFileName": "200-01",
            "IconUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "IconFileName": "300-01",
            "IconUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
        ]
      },
      {
        "MarkCode": "101",
        "MarkGroupCode": "01",
        "MarkName": "テスト1",
        "MarkCodeBranch": "01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconList": [
          {
            "IconFileName": "100-01",
            "IconUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
          {
            "IconFileName": "300-01",
            "IconUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
          },
        ]
      },
      {
        "MarkCode": "102",
        "MarkGroupCode": "01",
        "MarkName": "テスト2",
        "MarkCodeBranch": "01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
        "IconList": []
      },
    ],
  },
};

const getMarkFileListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MarkCode": "0",
        "MarkCodeBranch": "01",
        "MarkFileName": "000_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//000_01.png",
        "MarkGroupCode": "01",
        "MarkName": "test1",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "1",
        "MarkCodeBranch": "01",
        "MarkFileName": "001_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "01",
        "MarkName": "test2",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "2",
        "MarkCodeBranch": "01",
        "MarkFileName": "002_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "02",
        "MarkName": "９９：マーケットプライス",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "2",
        "MarkCodeBranch": "02",
        "MarkFileName": "002_02",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "03",
        "MarkName": "９９：マーケットプライス",
        "SupplyPromoteMarkDiv": "1",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "2",
        "MarkCodeBranch": "03",
        "MarkFileName": "002_03",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "９９：マーケットプライス",
        "SupplyPromoteMarkDiv": "2",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "3",
        "MarkCodeBranch": "01",
        "MarkFileName": "003_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "test3",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "4",
        "MarkCodeBranch": "01",
        "MarkFileName": "004_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "test4",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "5",
        "MarkCodeBranch": "01",
        "MarkFileName": "005_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "test5",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "6",
        "MarkCodeBranch": "01",
        "MarkFileName": "006_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "test6",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "7",
        "MarkCodeBranch": "01",
        "MarkFileName": "007_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "04",
        "MarkName": "test7",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "8",
        "MarkCodeBranch": "01",
        "MarkFileName": "008_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test8",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "9",
        "MarkCodeBranch": "01",
        "MarkFileName": "009_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test9",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "10",
        "MarkCodeBranch": "01",
        "MarkFileName": "010_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test10",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "11",
        "MarkCodeBranch": "01",
        "MarkFileName": "011_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test11",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "12",
        "MarkCodeBranch": "01",
        "MarkFileName": "012_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test12",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "13",
        "MarkCodeBranch": "01",
        "MarkFileName": "013_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test13",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "14",
        "MarkCodeBranch": "01",
        "MarkFileName": "014_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test14",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
      {
        "MarkCode": "15",
        "MarkCodeBranch": "01",
        "MarkFileName": "015_01",
        "MarkFileUrl": "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png",
        "MarkGroupCode": "05",
        "MarkName": "test15",
        "SupplyPromoteMarkDiv": "0",
        "RegistDate": "20240216",
      },
    ],
  },
};

const getMarkFileListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}

const getMarkPublishOrderListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        MarkGroupCode: '01',
        MarkCode: '002',
        MarkName: '02:くらし応援',
        PublishOrder: '2',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '01',
        MarkCode: '001',
        MarkName: '01:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '01',
        MarkCode: '033',
        MarkName: '33:くらし応援',
        PublishOrder: '33',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '01',
        MarkCode: '004',
        MarkName: '04:くらし応援',
        PublishOrder: '4',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '02',
        MarkCode: '005',
        MarkName: '05:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '02',
        MarkCode: '100',
        MarkName: '05:くらし応援',
        PublishOrder: '2',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '02',
        MarkCode: '200',
        MarkName: '05:くらし応援',
        PublishOrder: '3',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '03',
        MarkCode: '006',
        MarkName: '06:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '04',
        MarkCode: '007',
        MarkName: '07:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '05',
        MarkCode: '008',
        MarkName: '08:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '06',
        MarkCode: '009',
        MarkName: '09:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '07',
        MarkCode: '010',
        MarkName: '10:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '08',
        MarkCode: '011',
        MarkName: '11:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '09',
        MarkCode: '012',
        MarkName: '12:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '10',
        MarkCode: '013',
        MarkName: '13:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '11',
        MarkCode: '014',
        MarkName: '14:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '12',
        MarkCode: '015',
        MarkName: '15:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        MarkGroupCode: '13',
        MarkCode: '016',
        MarkName: '16:くらし応援',
        PublishOrder: '1',
        MarkFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
    ]
  }
}

const getCwsIconPublishOrderListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        GroupCode: '01',
        IconCode: '002',
        IconName: '02:くらし応援',
        PublishOrder: '2',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '01',
        IconCode: '001',
        IconName: '01:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '01',
        IconCode: '033',
        IconName: '33:くらし応援',
        PublishOrder: '33',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '01',
        IconCode: '004',
        IconName: '04:くらし応援',
        PublishOrder: '4',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '02',
        IconCode: '005',
        IconName: '05:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '03',
        IconCode: '006',
        IconName: '06:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '04',
        IconCode: '007',
        IconName: '07:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '05',
        IconCode: '008',
        IconName: '08:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '06',
        IconCode: '009',
        IconName: '09:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '07',
        IconCode: '010',
        IconName: '10:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '08',
        IconCode: '011',
        IconName: '11:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '09',
        IconCode: '012',
        IconName: '12:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '10',
        IconCode: '013',
        IconName: '13:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '11',
        IconCode: '014',
        IconName: '14:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '12',
        IconCode: '015',
        IconName: '15:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
      {
        GroupCode: '13',
        IconCode: '016',
        IconName: '16:くらし応援',
        PublishOrder: '1',
        IconFileUrl: 'http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205',
      },
    ]
  }
}

const getCwsIconPublishOrderListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}

const getCwsIconBaseDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      IconCode: '123',
      IconCodeBranch: '01',
      IconName: 'アレルゲン',
      IconGroupCode: '10',
      IconDiv: '1',
      ArrangeDiv: '1',
      IconExplain: '1',
      // OutputDiv: '00100010',
      OutputDiv: '11111111',
      StartOrderCode: '2023160',
      // StartOrderCode: '0000000',
      EndOrderCode: '2023160'
      // EndOrderCode: '9999999'
    }
  }
}

const getCwsIconBaseDataResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
    }
  }
}
